/* eslint-disable react/prop-types */
import React, {useEffect, useState} from 'react';
import {Text} from "./styles";
import {formatCurrency} from "../../utils/functions";
import {useApp} from "../../contexts/AppContext";
import {getPaymentConditions} from "../../_services/payment.service";
import * as Promisse from "axios";

export const ResumeCar = () => {
    const {carState} = useApp()
    const {car, datesSearchCar, offersCar} = carState

    const [pointsAmount, setPointsAmount] = useState( {
        taxesAmount: 0,
        totalAmount: 0
    })

    useEffect(() => {
        const request = async () => {
            if (offersCar === 'points') {
                let bodyTax = {
                    "amount": car.fareSummary.taxesAmount
                }

                let bodyAmount = {
                    "amount": car.fareSummary.originalDisplayTotalAmount
                }

                const [
                    tax,
                    amount
                ] = await Promise.all([
                    getPaymentConditions(bodyTax),
                    getPaymentConditions(bodyAmount)
                ])

                setPointsAmount({
                    taxesAmount: tax.WL,
                    totalAmount: amount.WL
                })
            }
        }
        request()
    }, [])

    return (
        <>
            <Text>
                <p>Locação de carro</p>
                <p>{car?.car?.category}</p>
            </Text>
            <Text>
                <p>{datesSearchCar.days} Diária{datesSearchCar.days > 1 && 's'}</p>
                <p>
                    {offersCar === 'cash' && formatCurrency(car.amount.BRL)}
                    {offersCar === 'points' && parseFloat(car.amount.WL).toLocaleString() + ' pontos'}
                </p>
            </Text>
            <Text>
                <p>Taxas</p>
                <p>
                    {offersCar === 'cash' && formatCurrency(car.fareSummary.taxesAmount)}
                    {offersCar === 'points' && parseFloat(pointsAmount.taxesAmount).toLocaleString() + ' pontos'}
                </p>
            </Text>
            <Text>
                <p>Total do pedido</p>
                <p>
                    {offersCar === 'cash' && formatCurrency(car.fareSummary.originalDisplayTotalAmount)}
                    {offersCar === 'points' && parseFloat(pointsAmount.totalAmount).toLocaleString() + ' pontos'}
                </p>
            </Text>
        </>
    )
}

export const ResumeHotel = () => {
    const { hotelState } = useApp()
    const { datesSearchHotel, room, offersHotel } = hotelState

    const [pointsAmount, setPointsAmount] = useState( {
        taxesAmount: 0,
        totalAmount: 0
    })

    let totalDaily;
    let taxDaily;
    let total;

    useEffect(() => {
        const request = async () => {
            if (offersHotel === 'points') {

                let bodyTax = {
                    "amount": room?.dailyTax?.value
                }

                let bodyAmount = {
                    "amount": room?.amount.BRL * datesSearchHotel.days
                }

                const [
                    totalTax,
                    totalPayment
                ] = await Promisse.all([
                    getPaymentConditions(bodyTax),
                    getPaymentConditions(bodyAmount)
                ])

                setPointsAmount({
                    taxesAmount: totalTax.WL,
                    totalAmount: totalPayment.WL
                })
            }
      }

        request()
    }, [])


    if (offersHotel === 'points') {
        totalDaily = parseFloat(room?.amount.WL).toLocaleString()+' Pts'
        taxDaily = pointsAmount.taxesAmount ? parseFloat(pointsAmount.taxesAmount).toLocaleString() : 0 +' Pts'

        const calcSumPoints = (room?.amount.WL * datesSearchHotel.days) + pointsAmount.taxesAmount
        total = parseFloat(calcSumPoints).toLocaleString()+' Pts'
    } else {
        totalDaily = formatCurrency(room?.amount.BRL)
        taxDaily =  formatCurrency(room?.dailyTax?.value)

        const calcSum = (room?.amount.BRL * datesSearchHotel.days) + room?.dailyTax?.value
        total = formatCurrency(calcSum)
    }

    return (
        <>
            <Text>
                <p>Quarto</p>
                <p>{room?.name}</p>
            </Text>
            <Text>
                <p>{datesSearchHotel.days} Diária{datesSearchHotel.days > 1 && 's'}</p>
                <p>
                    { totalDaily }
                </p>
            </Text>
            <Text>
                <p>Taxas</p>
                <p>{ taxDaily }</p>
            </Text>
            <Text>
                <p>Total do pedido</p>
                <p>{ total }</p>
            </Text>
        </>
    )
}